<template>
    <v-layout row wrap justify-center>
        <div style="text-align: center; padding: 25px 0 0 0" class="white--text display-1">
            Vorsi.io has affordable plans for all organizations!
        </div>
    </v-layout>
</template>

<script>
    export default {
        name: "Overview"
    }
</script>

<style scoped>

</style>